const members = [
    {
        "name":"Ayush Mishra",
        "image":"images/ayush.png",
        "linkedIn":"https://www.linkedin.com/in/ayush-mishra-350a80195/",
        "github":"https://github.com/ayush4545",
        "instagram":""
    },
    {
        "name":"Nikhil Singh",
        "image":"images/nikhil.png",
        "linkedIn":"https://www.linkedin.com/in/nikhil-singh-97b696206/",
        "github":"https://github.com/AM-SAPP/",
        "instagram":"https://www.instagram.com/nikhil_singh_20/"
    },
    {
        "name":"Narendra Singh Bajwal",
        "image":"images/nikky.png",
        "linkedIn":"https://www.linkedin.com/in/narendra-singh-bajwal",
        "github":"https://github.com/geeknarendra",
        "instagram":"https://instagram.com/narendrabajwal"
    },
    {
        "name":"Gajendra sharma",
        "image":"images/gajendra.png",
        "linkedIn":"https://www.linkedin.com/in/gajendra-sharma-a107011b3",
        "github":"https://github.com/Gajendra-design",
        "instagram":"https://www.instagram.com/gajendra9049"
    }
]

export default members;